import React from 'react'

import IconList from '@cinch/oxd-components/icon-list/src'
import { HomeDelivery } from '@cinch/oxd-components/icons/src'
import Modal from '@cinch/oxd-components/modal/src/'

import { Delivery } from '../../delivery-preference.component'

import * as cardStyles from './delivery-modal-card.module.css'
import * as styles from './delivery-modal.module.css'

const HomeDeliveryIcon = HomeDelivery as any

interface DeliveryModalProps {
  i18n: Delivery['deliveryModal']

  onClose: () => void
}

const DeliveryModal: React.FC<DeliveryModalProps> = ({ i18n, onClose }) => {
  const bulletText = Object.keys(i18n).map((item) => i18n[item as keyof typeof i18n])

  return (
    <div className={styles.deliveryModal}>
      <Modal onClose={onClose} cardStyles={cardStyles}>
        <div className={styles.homeDeliveryIcon}>
          <HomeDeliveryIcon role="presentation" />
        </div>
        <IconList
          bulletText={bulletText.map((bullet) => bullet)}
          hasGradient={true}
          gradientId={'bravo'}
          doesWrap={false}
          className={cardStyles.modalIconList}
          itemClassName={cardStyles.cardListItem}
        />
      </Modal>
    </div>
  )
}

export default DeliveryModal
